<template>
    <div>
        <form id="contact-user" class="contact-form" action="" method="POST" @submit.prevent="submit" novalidate>
            
            <div class="input-section col-2">
                <form-input-type-text
                    name="first_name"
                    label="Name"
                    :errors="errors.first_name"
                    required
                    full-border
                ></form-input-type-text>

                <form-input-type-text 
                    name="last_name" 
                    label="Surname" 
                    :errors="errors.last_name"
                    required
                    full-border
                ></form-input-type-text>
            </div>

            <div class="input-section col-2">
                <form-input-type-email
                    name="email"
                    label="E-mail"
                    :errors="errors.email"
                    required
                    full-border
                ></form-input-type-email>
    
                <form-input-type-text
                    name="phone"
                    label="Phone"
                    :errors="errors.phone"
                    required
                    full-border
                ></form-input-type-text>
            </div>

            <form-input-type-text
                v-if="this.positionDetail"
                name="personal_url"
                label="Link to your profile (LinkedIn, GitLab, etc.)"
                full-border
            ></form-input-type-text>

            <form-input-upload-file
                name="files"
                label="Upload your CV or Cover letter"
                :max-files-count="2"
                :allowed-files="['.pdf', '.doc', '.docx']"
                :errors="errors.files"
            ></form-input-upload-file>

            <form-input-type-text-area
                name="text"
                label="Message"
                :errors="errors.text"
                full-border
            ></form-input-type-text-area>

            <form-input-type-checkbox
                :label="`I agree to the processing of my <a href='/uploads/manual_uploads/${this.dataPrivacyLink()}' target='blank'>personal data</a>.`"
                name="agreements"
                :errors="errors.agreements"
                required
            ></form-input-type-checkbox>

            <div class="input-section">
                <div class="form-footer">
                    <div class="form-send">
                        <v-button v-if="this.positionDetail" label="Send" size="lg" type="submit"></v-button>
                        <v-button v-else label="Get in touch" color="green" size="lg" type="submit" full-width></v-button>
                    </div>
                </div>
            </div>
        </form>

        <flash-alert
            v-if="showAlert"
            @closeAlert="close"
            :text="__('Thank you for your message. Someone from our team will get back to you soon! Have a nice day.')"
            position="top"
        ></flash-alert>
        <flash-alert
            v-if="failed"
            level="danger"
            @closeAlert="close"
            :text="__('Failed to send. Please try again.')"
            position="top"
        ></flash-alert>
    </div>
</template>
<script>
    import localforage from 'localforage'
    
    export default {
        props: {
            positionDetail: {
                type: Boolean,
                required: false,
                default: false
            },
            jobId: {
                type: String,
                required: false
            },
            privacyLangEn: {
                type: Boolean,
                required: false,
                default: true
            }
        },

        data() {
            return {
                errors: {},
                showAlert: false
            }
        },
        mounted() {
            $('.item-contact').addClass('active')

            var that = this

            localforage.getItem('contact-successfully-send', function (err, value) {
                if(value) {
                    that.showAlert = true

                    localforage.removeItem('contact-successfully-send')
                }
            });
        },
        computed: {
            failed() {
                if(this.errors && this.errors['g-recaptcha-response']) {
                    return true
                } else {
                    return false
                }
            }
        },
        methods: {
            submit() {
                let that = this
                const fileInput = document.querySelector("input[type=file]");
                const fileList = fileInput.files;
                const formData = new FormData()
                
                if (fileList.length > 0) {
                    for (let i = 0; i < fileList.length; i++) {
                        formData.append(`files[${i}]`, fileList[i])
                    }
                } 
                
                grecaptcha.ready(function() {
                    grecaptcha.execute('6Ld1xdAcAAAAADk0PETFBUMbW366obkv65EmHObU', {action: 'submit'}).then(function(token) {
                        // serialize form data
                        $('#contact-user')
                            .serializeArray()
                            .forEach(({ name, value }) => {
                                formData.append(name, value)
                            })

                        formData['g-recaptcha-response'] = token

                        if (that.positionDetail) {
                            let uri = new URI(location.href)
                            const jobId = that.jobId

                            formData.append('job_id', jobId)

                            axios
                                .post(uri.origin() + '/api/datacruit-hiring-form', formData, {
                                    headers: {
                                        'Accept-Language': 'en'
                                    }
                                })
                                .then((e) => {
                                    that.$emit('sent')
                                })
                                .catch((e) => {
                                    console.log(e)
                                    that.errors = e.response.data.errors
                                    Vuemit.fire('Button--sending-failed', true)
                                    that.scrollToError()
                                })
                        } else {                            
                            axios
                                .post('api/hiring-form', formData, {
                                    headers: {
                                        'Accept-Language': 'en'
                                    }
                                })
                                .then((e) => {
                                    localforage.setItem('contact-successfully-send', true)
                                    location.reload()
                                })
                                .catch((e) => {
                                    console.log(e.response)
                                    that.errors = e.response.data.errors
                                    Vuemit.fire('Button--sending-failed', true)
                                    that.scrollToError()
                                })
                        }
                    })
                })
            },

            close() {
                this.showAlert = false
            },

            dataPrivacyLink() {
                if (this.privacyLangEn) {
                    return 'Consent_to_processing_of_personal_data_DE_(EN).pdf'
                }

                return 'Consent_to_processing_of_personal_data.cz.pdf'
            },

            async scrollToError() {
                await this.$nextTick()

                var firstError = document.querySelector('.input-error-border')

                $('html, body').animate(
                    {
                        scrollTop: $(firstError).offset().top - 180
                    },
                    800
                )
            }
        }
    }
</script>
